import { Typography } from '@lno/components/Typography'
import { useCampaign } from '@lno/core/hooks/useCampaign'
import { GASelectContentEvent } from '@lno/core/modules/analytics/events'
import clsx from 'clsx'
import { HightlightedLink } from '../../HightightedLink'
import { URLS } from '../constants'
import { styles } from '../styles'

const jsxScope = `jsx-${styles.__hash}`

export const DesenrolaBrasilTitle = () => {
  const { isActiveCampaign } = useCampaign()
  const TitleDesenrola = isActiveCampaign
    ? 'O MegaFeirão Serasa e Desenrola prorrogou!​'
    : 'A Serasa é parceira oficial do Desenrola Brasil​'
  return (
    <Typography
      size="headingM"
      color="high"
      className={clsx(jsxScope, 'debt-negotiation-program-section__title')}
      tag="h2"
    >
      {TitleDesenrola}
    </Typography>
  )
}

export const DesenrolaBrasilDescription = () => {
  const { isActiveCampaign } = useCampaign()
  const handleEvent = {
    megaFeirao: GASelectContentEvent.megaFeiraoEvent,
    desenrola: GASelectContentEvent.desenrolaBrasilEvent,
    appInstall: GASelectContentEvent.desenrolaAppInstall,
    desenrolaOffersWeb: GASelectContentEvent.desenrolaOffersWeb,
  }

  return (
    <div
      className={clsx(
        jsxScope,
        'debt-negotiation-program-section__description'
      )}
    >
      {isActiveCampaign ? (
        <>
          <Typography size="bodyM" color="medium" tag="p">
            Com mais de 700 empresas, o Desenrola Brasil, os Correios e
            concessionárias de água e luz, o
            <HightlightedLink
              href={URLS.megaFeirao}
              onClick={handleEvent.megaFeirao}
            >
              {' '}
              <Typography tag="span" size="bodyM" weight="bold" color="accent">
                Mega
              </Typography>
              Feirão Serasa e Desenrola
            </HightlightedLink>{' '}
            foi prorrogado nos canais digitais da Serasa.
          </Typography>
          <br />
          <Typography size="bodyM" color="medium" tag="p">
            Além de visualizar as ofertas do{' '}
            <HightlightedLink
              href={URLS.desenrola}
              onClick={handleEvent.desenrola}
            >
              Desenrola Brasil
            </HightlightedLink>{' '}
            e acessar a plataforma do programa, você pode encontrar descontos de
            até 99% em ofertas que incluem dívidas de água, energia, gás,
            bancos, telefonia, varejo e universidades.
          </Typography>
          <br />
          <Typography size="bodyM" color="medium" tag="p">
            O MegaFeirão Serasa e Desenrola foi prorrogado até o dia 31 de
            março. Aproveite as{' '}
            <Typography tag="span" size="bodyM" weight="bold" color="accent">
              últimas horas
            </Typography>{' '}
            para negociar com rapidez e segurança por meio do{' '}
            <HightlightedLink
              href={URLS.desenrolaAppInstall}
              onClick={handleEvent.appInstall}
            >
              aplicativo
            </HightlightedLink>
            ,{' '}
            <HightlightedLink
              href={URLS.desenrolaOffersWeb}
              onClick={handleEvent.desenrolaOffersWeb}
            >
              site da Serasa
            </HightlightedLink>
            .
          </Typography>
        </>
      ) : (
        <>
          <Typography size="bodyM" color="medium" tag="p">
            O{' '}
            <HightlightedLink
              href={URLS.desenrola}
              onClick={handleEvent.desenrola}
            >
              Desenrola Brasil
            </HightlightedLink>{' '}
            foi prorrogado até o dia 20 de maio! Na Serasa você visualiza as
            ofertas do programa do Governo Federal.​
          </Typography>
          <br />
          <Typography size="bodyM" color="medium" tag="p">
            Baixe o{' '}
            <HightlightedLink
              href={URLS.desenrolaAppInstall}
              onClick={handleEvent.appInstall}
            >
              aplicativo
            </HightlightedLink>{' '}
            ou acesse o{' '}
            <HightlightedLink
              href={URLS.desenrolaOffersWeb}
              onClick={handleEvent.desenrolaOffersWeb}
            >
              site da Serasa
            </HightlightedLink>{' '}
            para consultar suas dívidas e acessar a plataforma oficial do
            programa.​
          </Typography>
        </>
      )}
    </div>
  )
}
